module.exports = __webpack_public_path__ + "img/data_moun_sc.c811743b.png";